import { extend } from '@syncfusion/ej2-base'
import { useMemo, useRef } from 'react'

type ScheduleEvent = {
  id: number
  room_id?: string
  start_time: string | Date
  end_time: string | Date
  updated_at?: string
  emr_updated_at?: string | null
  sms_notification?: string | number
  temperature?: number | null
  consultation_staff?: number
  consultation_staff_name?: string
  current_location?: string | null
  status?: { code?: number }
  category?: { code?: number }
  title?: string
}

const toFingerprintTime = (value: string | Date): string | number =>
  value instanceof Date ? value.getTime() : value

const fingerprintEvents = (events: ScheduleEvent[]): string =>
  events
    .map((event) =>
      [
        event.id,
        event.room_id,
        toFingerprintTime(event.start_time),
        toFingerprintTime(event.end_time),
        event.updated_at ?? '',
        event.emr_updated_at ?? '',
        event.status?.code ?? '',
        event.category?.code ?? '',
        event.title ?? '',
        event.sms_notification ?? '',
        event.temperature ?? '',
        event.consultation_staff ?? '',
        event.consultation_staff_name ?? '',
        event.current_location ?? '',
      ].join('|'),
    )
    .join(';')

export const useStableScheduleDataSource = <T extends ScheduleEvent>(events: T[]): T[] => {
  const dataRef = useRef<T[]>([])
  const fingerprintRef = useRef('')

  return useMemo(() => {
    const fingerprint = fingerprintEvents(events)
    if (fingerprint === fingerprintRef.current) {
      return dataRef.current
    }

    fingerprintRef.current = fingerprint
    const next = extend([], events, null, true) as T[]
    dataRef.current = next
    return next
  }, [events])
}
